/* global OfficeRuntime */
const TOKEN_KEY = "cognito_token";
const REFRESH_KEY = "cognito_refresh_token";
const EXPIRES_KEY = "cognito_expires_at";
const EMAIL_KEY = "cognito_email";

export async function getToken(): Promise<string | null> { return OfficeRuntime.storage.getItem(TOKEN_KEY); }
export async function setToken(t: string): Promise<void> { await OfficeRuntime.storage.setItem(TOKEN_KEY, t); }

export async function getRefreshToken(): Promise<string | null> { return OfficeRuntime.storage.getItem(REFRESH_KEY); }
export async function setRefreshToken(t: string): Promise<void> { await OfficeRuntime.storage.setItem(REFRESH_KEY, t); }

export async function getExpiresAt(): Promise<string | null> { return OfficeRuntime.storage.getItem(EXPIRES_KEY); }
export async function setExpiresAt(v: string): Promise<void> { await OfficeRuntime.storage.setItem(EXPIRES_KEY, v); }

export async function getEmail(): Promise<string | null> { return OfficeRuntime.storage.getItem(EMAIL_KEY); }
export async function setEmail(v: string): Promise<void> { await OfficeRuntime.storage.setItem(EMAIL_KEY, v); }

export async function clearAllAuth(): Promise<void> {
  await Promise.all([
    OfficeRuntime.storage.removeItem(TOKEN_KEY),
    OfficeRuntime.storage.removeItem(REFRESH_KEY),
    OfficeRuntime.storage.removeItem(EXPIRES_KEY),
    OfficeRuntime.storage.removeItem(EMAIL_KEY),
  ]);
}

export async function clearSessionTokens(): Promise<void> {
  await Promise.all([
    OfficeRuntime.storage.removeItem(TOKEN_KEY),
    OfficeRuntime.storage.removeItem(REFRESH_KEY),
    OfficeRuntime.storage.removeItem(EXPIRES_KEY),
  ]);
}
